// Copyright (c) 2025 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

import { toast } from '@iota/core';

export function onCopySuccess() {
    toast.success('Copied to clipboard');
}
